module.exports = __webpack_public_path__ + "img/Dietitian.904c1875.jpg";